export default __webpack_public_path__ + "static/media/icon_share_url.c4c79823.svg";